import $ from "jquery";
import ko from "knockout";


var h = ko.bindingHandlers;

var n = "dependendOptions";

h[n] = {
	init: function(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
		// save original list of options
		$(element).data("ko-dependendOptions", ko.utils.arrayMap(element.options, function(e) {
			return $.extend({}, $(e).data(), { value: e.value, text: e.text });
		}));
		return ko.bindingHandlers.options.init(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);
	},
	update: function(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
		// get binding options;
		var options = ko.unwrap(valueAccessor());
		// touch dependent value;
		var accessor = typeof options.dependsOn == "function" ? options.dependsOn : function() { return viewModel[options.dependsOn]; };
		var value = ko.unwrap(accessor());
		var opt = $(element).data("ko-dependendOptions");
		function makeFilter(opt, f, value) {
			return function() {
				return ko.utils.arrayFilter(opt, f ? function(e) { return f.call(bindingContext, e, value); } : function() { return true; });
			};
		}
		return ko.bindingHandlers.options.update(element,
			makeFilter(opt, options.filter, value),
			allBindingsAccessor, viewModel, bindingContext);
	}
};

// value binding was simplified in KO 3.5.1
if(!h.value.after) h.value.after = [];
h.value.after.push(n);


ko.bindingHandlers.files = {
	init: function (element, valueAccessor/*, allBindings, viewModel, bindingContext*/) {
		function updateValue(elementValue) {
			var valueSetter = valueAccessor();
			valueSetter.splice.apply(valueSetter, [0, 100000].concat(elementValue));
		}
		updateValue([]);
		ko.utils.registerEventHandler(element, "change", function () {
			var elementValue = Array.prototype.map.call(element.files, function (f) {
				return { name: f.name, type: f.type, size: f.size, lastModified: f.lastModified };
			});
			updateValue(elementValue);
		});
	},
	update: function (element, valueAccessor/*, allBindings, viewModel, bindingContext*/) {
		var value = ko.unwrap(valueAccessor());
		// reset file input if null, [] or ""
		if (value == null || value.length == 0)
			element.value = "";
	}
};

function initKOForm() {
	/* jshint validthis: true */
	if(this.tagName != "FORM")
		throw "not a form element";

	var model = {};
	var els = this.elements;
	for(var i = 0, l = els.length; i < l; i++) {
		var v = null,
		el = els[i],
		n = el.name,
		m = false, // multiple elements?
		db = /\b(?:checked|value|textInput|files):([A-Za-z0-9_]+)/.exec(el.getAttribute("data-bind") || "");
		if(!n || !db) continue;
		db = db[1];
		if(el.tagName == "INPUT" && el.type == "file" && el.multiple)
			v = [];
		else if(el.tagName == "INPUT" && el.type == "checkbox") // for checkbox it's a true/false, unless we have many under the same name
			v = (m = (els[n].length > 1)) == true ? el.checked ? el.value : null : el.checked;
		else if(el.tagName != "INPUT" || el.type != "radio" || el.checked)
			v = el.value;
		if(model[db] == null)
			model[db] = m ? v != null ? [v] : [] : v;
		else if(Array.isArray(model[db]) && v != null)
			model[db].push(v);
		else if(v != null)
			model[db] = [model[db], v];
	}
	// QFE to keep resolving dependencies when "parent" control is not visible
	// cell readonly or whatver. Find elements with "default-data-bind" and
	// extend the model if the value is not set already
	$($.makeArray(els)).each(function() {
		var def = $(this).data("bind-default");
		if(def !== undefined) {
			for(var k in def) {
				if(model[k] === undefined)
					model[k] = def[k];
			}
		}
	});
	for(var mm in model) {
		model[mm] = Array.isArray(model[mm]) ?
			ko.observableArray(model[mm]) :
			ko.observable(model[mm]);
	}
	ko.applyBindings(model, this);
	$(this).data("ko-model", model);
}

$.fn.komodel = function() {
	return this.each(initKOForm);
};
